<!-- <p>hierarchy-manage-asset works!</p> -->
<ejs-tab id="element" *ngIf="selectedAsset">
	<e-tabitems>
		<e-tabitem>
			<ng-template #headerText>
				<span class="app-icon app-icon--analytics"><mat-icon />&nbsp;Properties</span>
			</ng-template>
			<ng-template #content>
				<div>
					<ng-container *ngTemplateOutlet="propertiesTab"></ng-container>
				</div>
			</ng-template>
		</e-tabitem>
		<e-tabitem>
			<ng-template #headerText>
				<span class="app-icon app-icon--sensors"><mat-icon />&nbsp;DataPoints</span>
			</ng-template>
			<ng-template #content>
				<div>
					<ng-container *ngTemplateOutlet="datapointsTab"></ng-container>
				</div>
			</ng-template>
		</e-tabitem>
		<e-tabitem>
			<ng-template #headerText>
				<span class="app-icon app-icon--rules"><mat-icon />&nbsp;Rules</span>
				<mat-icon *ngIf="hasActiveRules" style="margin-left: 0.2em; color: red;">notifications_active</mat-icon>
			</ng-template>
			<ng-template #content>
				<div>
					<ng-container *ngTemplateOutlet="rulesTab"></ng-container>
				</div>
			</ng-template>
		</e-tabitem>
		<e-tabitem *ngIf="checkFeature(AccountFeatures.Asset_Information)">
			<ng-template #headerText>
				<span class="app-icon app-icon--information"><mat-icon />&nbsp;Information</span>
			</ng-template>
			<ng-template #content>
				<div>
					<ng-container *ngTemplateOutlet="informationTab"></ng-container>
				</div>
			</ng-template>
		</e-tabitem>
		<e-tabitem *ngIf="checkFeature(AccountFeatures.Tile_Customisation)">
			<ng-template #headerText>
				<span class="tile-icon"><mat-icon />&nbsp;Tile</span>
			</ng-template>
			<ng-template #content>
				<div>
					<ng-container *ngTemplateOutlet="tileTab"></ng-container>
				</div>
			</ng-template>
		</e-tabitem>
		<e-tabitem *ngIf="checkFeature(AccountFeatures.Virtual_Sensors)">
			<ng-template #headerText>
				<span class="app-icon app-icon--mediation"><mat-icon />&nbsp;Virtual DataPoints</span>
			</ng-template>
			<ng-template #content>
				<div>
					<ng-container *ngTemplateOutlet="virtualSensorTab"></ng-container>
				</div>
			</ng-template>
		</e-tabitem>
	</e-tabitems>
</ejs-tab>

<ng-template #tabHeading let-showMenu="showMenu">
	<div style="display: flex;" class="location-title alignRow" *ngIf="selectedAsset">
		<span class="app-icon app-icon--asset" style="padding: 0px; margin-right: 0.5em;"><mat-icon /></span>
		<span>Asset: {{selectedAsset.Name}}</span>
		<span *ngIf="selectedAsset.Description != selectedAsset.Name &&
			!!selectedAsset.Description">&nbsp;-&nbsp;{{selectedAsset.Description}}</span>
		<mat-icon *ngIf="selectedAsset.Hidden" style="margin-left: 10px; margin-top: 0px;"
			matTooltip="This Asset is Hidden">visibility_off</mat-icon>
		<span class="toolbar-spacer"></span>
		<button *ngIf="!selectedAsset.Hidden" mat-raised-button color="primary" style="margin-right: 9px;"
			(click)="goToAsset()">
			<span>Go to Asset</span>
			<mat-icon>north_east</mat-icon>
		</button>
		<div class="toolbar-buttons alignRow" *ngIf="showMenu">
			<span (click)="toggleHidden()" style="margin: 0.5em !important;" class="alignRow">
				<mat-icon *ngIf="!selectedAsset.Hidden" matTooltip="Hide Asset">visibility_off</mat-icon>
				<mat-icon *ngIf="selectedAsset.Hidden" matTooltip="Unhide Asset">visibility</mat-icon>
			</span>
			<span class="app-icon app-icon--delete" (click)="deleteAsset()"
				matTooltip="Delete Asset"><mat-icon /></span>
		</div>
	</div>
	<hr style="min-width: 56vw;">
</ng-template>

<ng-template #propertiesTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:true}"></ng-container>
	<div class=" content-body">
		<form [formGroup]="assetForm">
			<div *ngIf="error" class="alert alert-danger">{{error}}</div>
			<div *ngIf="success" class="alert alert-success">{{success}}</div>
			<mat-form-field appearance="fill">
				<mat-label>Code/Alias (Diaplay Name)</mat-label>
				<input matInput autocomplete="off" readonly formControlName="Name" autocomplete="off">
			</mat-form-field>
			<mat-form-field appearance="fill">
				<mat-label>Asset Name</mat-label>
				<input matInput autocomplete="off" readonly formControlName="Description" autocomplete="off">
			</mat-form-field>
			<mat-form-field appearance="fill">
				@let Location = assetForm.get('FunctionLocation')?.value;
				<mat-label>Functional Location
					<small *ngIf="!Location" class="inherited">Inherited</small>
				</mat-label>
				@if (Location) {<input matInput autocomplete="off" readonly formControlName="FunctionLocation">} 
				@else {<input matInput autocomplete="off" readonly formControlName="ParentFunctionalLocation">}				
			</mat-form-field>
			<mat-form-field appearance="fill">
				<mat-label>Equipment Code</mat-label>
				<input matInput autocomplete="off" readonly formControlName="EquipmentCode">
			</mat-form-field>

			<div class="properties-image-container">
				<img class="properties-tab-image"
					(click)="viewImage(imagePathAssets()+selectedAsset.AssetID+'?'+selectedAsset.Modified)"
					src="{{imagePathAssets()}}{{selectedAsset.AssetID}}?{{selectedAsset.Modified}}"
					*ngIf="selectedAsset" title="{{selectedAsset.Name}}"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
					[attr.x-contenttype]="'image/png'" />
			</div>
			<button mat-button type="button" (click)="editAsset()"
				style="border-radius: 1em; border: 2px solid;margin-left: auto;margin-right: 1em;">
				Edit Asset
			</button>
		</form>
	</div>
</ng-template>

<ng-template #datapointsTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<nav class="location-title">
		<span>Datapoints: </span>
		<span class="toolbar-spacer"></span>
		<span class="app-icon app-icon--add" style="float: right;" matTooltip="Add Datapoint" (click)="addDatapoint()">
			<mat-icon />
		</span>
	</nav>
	<div class="content-body" *ngIf="assetDataPoints">
		<div class="listview-container">
			<ejs-listview [dataSource]='assetDataPoints' cssClass="e-list-template">
				<ng-template #template let-dataSource>
					<div class="ejs-listview-item listview-datapoint">
						<img class="image"
							(click)="viewImage(imagePathSensors()+dataSource.SensorID+'?'+dataSource.Modified)"
							src="{{imagePathSensors()}}{{dataSource.SensorID}}?{{dataSource.Modified}}"
							title="{{ dataSource.SensorName }}"
							onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
							[attr.x-contenttype]="'image/png'">
						<span class="detail">{{ dataSource.DPTitle }}</span>
						<span class="me-auto"></span>
						<div class="toggle">
							<mat-slide-toggle color="primary" [checked]="dataSource.ShowOnChart" style="margin: auto;"
								labelPosition="before" (change)="patchAssetDataPoint(dataSource, $event)">Show On
								Chart</mat-slide-toggle>
						</div>
						<!-- *ngIf="checkFeature(AccountFeatures.Tile_Customisation)" -->
						<div class="toggle">
							<mat-slide-toggle color="primary" [checked]="dataSource.ShowOnTile" style="margin: auto;"
								labelPosition="before" (change)="patchAssetDataPoint(dataSource, $event, true)">Show On
								Tile</mat-slide-toggle>
						</div>
						<div class="edit">
							<span class="app-icon app-icon--edit" style="margin: auto;">
								<mat-icon matTooltip="Edit {{ dataSource.DPTitle }}"
									(click)="editListDatapoint(dataSource)" />
							</span>
							<span class="app-icon app-icon--delete" style="margin: auto;">
								<mat-icon matTooltip="Remove {{ dataSource.DPTitle }}"
									(click)="deleteListDatapoint(dataSource)" />
							</span>
						</div>
					</div>
				</ng-template>
			</ejs-listview>
		</div>
	</div>
	<div class="location-title" *ngIf="!assetDataPoints">
		<span>This Asset Has No DataPoints</span>
	</div>
</ng-template>

<ng-template #rulesTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<nav class="location-title">
		<span>Asset Rules: </span>
		<span class="toolbar-spacer"></span>
		<span class="app-icon app-icon--add" (click)="createRule(selectedAsset)" matTooltip="Create New Rule"
			style="float: right;">
			<mat-icon />
		</span>
	</nav>
	<div class="content-body" *ngIf="assetRules && assetRules[0].RuleID != 0">
		<ejs-accordion>
			<e-accordionitems>
				<e-accordionitem *ngFor="let rule of assetRules" [expanded]="false">
					<!-- <ng-template #header>						
						<div style="text-decoration: underline; width: 100%;" class="alignRow">
							<mat-icon *ngIf="rule.Active"
								style="margin-right: 0.5em; color: red;">notifications_active</mat-icon>
							<span>{{ rule.RuleDescription }}</span>
						</div>
					</ng-template> -->
					<ng-template #header>
						<div class="alignRow ruleheader">
							<mat-icon *ngIf="rule.Active"
								style="margin-right: 0.5em; color: red;">notifications_active</mat-icon>
							<span>{{ rule.RuleDescription }}</span>
							<span class="me-auto"></span>
							<span><small *ngIf="!rule.RuleEnabled">Disabled</small></span>
						</div>
					</ng-template>
					<ng-template #content>
						<nav>
							<span style="font-weight: bolder; min-width: 30%;">Rule Information:</span>
							<div style="float: right; cursor: pointer; display: flex;">
								<span *ngIf="rule.CreatedByUserID" style="margin-right: 3em;">Created By:
									{{rule.CreatedByUserID}}</span>
								<span style="margin-right: 3em;">Rule ID: {{rule.RuleID}}</span>
								<div style="margin-right: 3em;">
									<mat-slide-toggle [checked]="rule.RuleEnabled" (change)="OnRuleEnable(rule, $event)"
										color="primary">Enabled</mat-slide-toggle>
								</div>
								<span class="app-icon app-icon--edit">
									<mat-icon matTooltip="Edit Rule" (click)="onEditRule(rule, $event)" />
								</span>
								<span class="app-icon app-icon--delete">
									<mat-icon matTooltip="Delete Rule" (click)="onDeleteRule(rule, $event)" />
								</span>
							</div>
						</nav>
						<div class="rule-info" [ngClass]="{'rule-active': rule.Active}">
							<span>Trigger Time:</span>
							<span>
								<span *ngIf="convertMinutesToHHMM(rule.TriggerTime)[0] != '00'">
									{{ convertMinutesToHHMM(rule.TriggerTime)[0] }} Hours and </span>
								<span *ngIf="rule.TriggerTime > 1">{{
									convertMinutesToHHMM(rule.TriggerTime)[1] }} Minutes</span>
								<span *ngIf="rule.TriggerTime == 1">{{
									convertMinutesToHHMM(rule.TriggerTime)[1] }} Minute</span>
							</span>
							<span></span>
							<span></span>
							<span>Rule Explanation:</span>
							<span style="text-decoration: underline;">DataPoint</span>
							<span style="text-decoration: underline;">Operator</span>
							<span style="text-decoration: underline;">Limit</span>
							<span>RULE WILL TRIGGER IF</span>
							<div *ngFor="let s of explainRule(rule); let i = index">
								<div [ngClass]="{'grid-def': ((i+1) % 4) != 0 }">
									<span>{{ s }}</span>
								</div>
							</div>
							<span>FOR</span>
							<span class="grid-def">{{ convertMinutesToHHMM(rule.TriggerTime)[0] }}:{{
								convertMinutesToHHMM(rule.TriggerTime)[1] }}</span>
						</div>
					</ng-template>
				</e-accordionitem>
			</e-accordionitems>
		</ejs-accordion>
	</div>
	<div class="location-title" *ngIf="assetRules && assetRules[0].RuleID == 0">
		<span>This Asset Has No Rules</span>
	</div>
</ng-template>

<ng-template #tileTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<div class="content-body">
		<div class="tile-customisation alignColumn alignRow alignColumn">
			<button mat-raised-button style="margin: auto;" (click)="deleteTileConfiguration()">
				<span>Reset to Default</span>
			</button>
			<div class="tile-options alignRow">
				<span>Display Asset Tile: </span>
				<mat-slide-toggle color="primary" [checked]="selectedAsset.DisplayOnImage"></mat-slide-toggle>
				<span>Number of DataPoints to Show: </span>
				<ejs-dropdownlist [dataSource]="[0,1,2,3,4]"
					[value]="existingConfig && existingConfig.NumberOfKPIs ? existingConfig.NumberOfKPIs : 0"
					(change)="numberOfKPIChange($event)">
					<ng-template #itemTemplate let-data>
						<div>
							<span>{{data}}</span>
						</div>
					</ng-template>
				</ejs-dropdownlist>
				<!-- <ejs-numerictextbox [(value)]="numberOfKPIs" [min]="0" [max]="4" [step]="1"
					[format]="'#'"></ejs-numerictextbox> -->
				<span>Background Colour: </span>
				<input ejs-colorpicker id='color-picker' type='color' [showButtons]="false" [modeSwitcher]="true"
					[value]="existingConfig && existingConfig.BackgroundColour ? existingConfig.BackgroundColour : '#ffffff'"
					(change)="backgroundColourChange($event)" />
				<span>Transparency (%)</span>
				<ejs-numerictextbox [value]="existingConfig && existingConfig.Opacity ? existingConfig.Opacity : 70"
					[min]="0" [max]="90" [step]="1" [format]="'##'"></ejs-numerictextbox>
			</div>
			<div class="tile-box">
				<app-asset-tile [accountGUID]="accountID" [OrganisationUID]="OrganisationID" [asset]="selectedAsset"
					[isFullScreen]="false" [editing]="true" [numberOfKPIs]="numberOfKPIs"
					[backgroundColour]="backgroundColour" (KPIConfigChange)="KPIConfigChange($event)"></app-asset-tile>
			</div>
			<button mat-raised-button style="margin: auto;" (click)="patchTileConfiguration()">
				<span>Confirm</span>
			</button>
		</div>
	</div>
</ng-template>

<ng-template #informationTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<app-asset-information [accountGUID]="accountID" [organisationUID]="OrganisationID" [asset]="selectedAsset"
		[account]="SelectedAccount"></app-asset-information>
</ng-template>

<ng-template #virtualSensorTab>
	<ng-container [ngTemplateOutlet]="tabHeading" [ngTemplateOutletContext]="{showMenu:false}"></ng-container>
	<app-virtual-sensors [asset]="selectedAsset"></app-virtual-sensors>
</ng-template>

<mat-menu #newEntry="matMenu" [overlapTrigger]="false" yPosition="below">
	<button mat-menu-item (click)="toggleHidden()" *ngIf="selectedAsset">
		<mat-icon *ngIf="!selectedAsset.Hidden">visibility_off</mat-icon>
		<mat-icon *ngIf="selectedAsset.Hidden">visibility</mat-icon>
		<span *ngIf="!selectedAsset.Hidden">Hide This Asset</span>
		<span *ngIf="selectedAsset.Hidden">Unhide This Asset</span>
	</button>
	<button class="app-icon app-icon--delete" mat-menu-item (click)="deleteAsset()" *ngIf="selectedAsset">
		<mat-icon /><span>Delete This Asset</span>
	</button>
</mat-menu>